module.exports = __webpack_public_path__ + "static/crush-it-6aae241cb46c6fa85e938ddbd1b1af4f.jpg";